/**
 * PCS-11271: true when the current user's Toriut account is hard-locked because
 * its 14-day trial has expired.
 *
 * `toriutAccessState` only ever lives on the account OWNER's user document
 * (stamped at signup, never for invited teammates). `user.team` is always the
 * owner's document - for the owner themself it's a copy of their own user
 * (`db.users.findUserWithTeamAndRole`: `user.team = {...user}`), for a teammate
 * it's a lookup of the real owner - so teammates must be gated on
 * `user.team.toriutAccessState`, not their own field. Mirrors the server's
 * `ensureToriutTrialAccess` middleware exactly.
 */
const isToriutTrialExpired = (user) => (user?.team || user)?.toriutAccessState === 'trial_expired';

export default isToriutTrialExpired;
